module.exports = {
  title: 'Textarea Form Field',
  context: {
    label: 'Label',
    placeholder: 'Example textarea form field.'
  }
}
